import React, { useCallback } from 'react'
import GetMyCertificateButton from './GetMyCertificateButton'
import NewAddOnSection from './NewAddOnSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPlus } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { setRating, setSkillName, setStudent } from '../../redux/addOnSlice'
import { setShowCourseModal } from '../../redux/otherDetailsSlice'
import constants from '../../utilities/constants'

const NewPriceCard = ({ originalPrice, discountPrice, handleNavigate, skillName, score, visitedAnalysisCartPage, innerRef }) => {

    const dispatch = useDispatch()

    const handlePersonaliseModal = useCallback((e) => {
        e.stopPropagation()
        dispatch(setRating(5))
        dispatch(setStudent(Math.floor((Math.random() * 1200) + 301)))
        dispatch(setSkillName(skillName))
        dispatch(setShowCourseModal(true))
    },[dispatch, skillName])

    return (
        <div className='text-center mt-6 p-3 bg-bg-13/20 rounded-2xl'>
            <img src="https://ik.imagekit.io/238r9emirjj/New%20Analysis%20Page/New%20Cert.%20Image.png?updatedAt=1741346454795" width={"100%"} height={"100%"} className='w-full h-full object-cover shadow-[0_0_11px_rgba(253,197,53,0.5)]' alt="" />
            <p className='text-xxs mt-2'><span className='text-shadow'>8/10</span> CVs With This Certificate Got Hired</p>
            {score < 60 && <div>
                <FontAwesomeIcon icon={faPlus} className='text-xl my-1' />
                <div className='bg-bg-9/20 py-2 px-3 text-xs w-full rounded-lg flex items-center gap-2'>
                    <img src="https://ik.imagekit.io/238r9emirjj/new-certificate-changes/4379787%203.svg?updatedAt=1732278221306" width={24} height={32} alt="" className='' />
                    <p className='flex-1 text-left leading-[140%]'>Your Quiz <span className='font-bold'>Performance Report & Solution Notes </span>Included <span className='uppercase font-bold'>Free</span> <FontAwesomeIcon icon={faCheck} className='text-check-mark text-base ml-1 -mb-[1px]' /></p>
                    <div className='text-center'>
                        <p className='text-xxs text-white/50 leading-[130%]'>Worth</p>
                        <p className='text-sm font-bold text-check-mark'>₹199</p>
                    </div>
                </div>
                {(visitedAnalysisCartPage && score < 40) && <div className='mt-2 bg-bg-9/20 py-2 px-3 text-xs w-full rounded-lg flex items-center gap-2' onClick={handlePersonaliseModal}>
                    <img src="https://ik.imagekit.io/238r9emirjj/new-certificate-changes/4379787%203.svg?updatedAt=1732278221306" width={24} height={32} alt="" className='' />
                    <p className='flex-1 text-left leading-[140%]'><span className='font-bold'>Personalised Course </span>Included <span className='uppercase font-bold'>Free</span> <img src="https://ik.imagekit.io/238r9emirjj/New%20Analysis%20Page/info-icon.svg?updatedAt=1742961190576" width={14} height={14} className='image-inline mr-1' alt="" /><FontAwesomeIcon icon={faCheck} className='text-check-mark text-base ml-1 -mb-[1px]' /></p>
                    <div className='text-right'>
                        <p className='text-xxs text-white/50 leading-[130%]'>Worth</p>
                        <p className='text-sm font-bold text-check-mark'>₹599</p>
                    </div>
                </div>}
            </div>}
            <div ref={innerRef} className='mt-4'>
                <GetMyCertificateButton
                    originalPrice={originalPrice}
                    discountPrice={discountPrice}
                    handleNavigate={handleNavigate}
                    event={constants.Mixpanel.ANALYSIS_PAGE_MAIN_PAYMENT_BUTTON_WAS_CLICKED}
                    text='For Just:'
                />
            </div>
            <NewAddOnSection
                skillName={skillName}
                visitedAnalysisCartPage={visitedAnalysisCartPage}
                score={score}
            />
        </div>
    )
}

export default NewPriceCard